import React, {useEffect, useState} from 'react';
import formatNumber from "../../utils/formatNumber";
import feather from "feather-icons";
import {userReport} from "../../api/app";
import Social from "./Social";
const $ = window.$;

const UserReport = (props) => {

    const [pages, setPages] = useState([]);

    useEffect(() => {
        feather.replace();
    }, []);

    useEffect(() => {
        userReport(props.id).then((response) => {
            $("#total-assignment").text(formatNumber(response.payload.total_task));
            $("#total-users").text(formatNumber(response.payload.total_submission));
            setPages(response.payload?.social?.pages);
        });
    }, []);

    return (
        <div className="col-12 col-lg-12">
            <div className="card mg-b-10">
                <div className="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                    <div>
                        <h6 className="mg-b-5">Influencer Performance</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">App user Performance.</p>
                    </div>
                </div>

                <div className="card-body pd-y-10">
                    <div className="d-sm-flex">
                        <div className="media align-items-center">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Total Tasks</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                            </div>
                        </div>
                        <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div className="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <i data-feather="bar-chart-2"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Total Submissions</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-users">0</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>

                <div>
                    <div className="card-header d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                        <div>
                            <h6 className="mg-b-5">Social Metric</h6>
                            <p className="tx-13 tx-color-03 mg-b-0">Performance.</p>
                        </div>
                    </div>

                    <div className="card-body pd-y-30">
                        <div className="d-sm-flex">
                            <div className="media align-items-center">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6" style={{backgroundColor: "#1877F2"}}>
                                    <i className="fab fa-facebook tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap">Facebook</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">0</h4>
                                </div>
                            </div>
                            <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-black-9 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                    <i className="fab fa-tiktok tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">TikTok</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                                </div>
                            </div>
                            <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                                <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                    <i className="fab fa-twitter tx-30"></i>
                                </div>
                                <div className="media-body">
                                    <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Twitter</h6>
                                    <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-dashboard mg-b-0">
                            <thead>
                            <tr>
                                <th>Social Platform</th>
                                <th className="text-right">Reach</th>
                                <th className="text-right">Engagement</th>
                                <th className="text-right">Views</th>
                                <th className="text-right">Shares</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-facebook mg-r-4"></i>Facebook</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>

                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize" style={{color: "black"}}><i className="fab fa-tiktok mg-r-4"></i>Tiktok</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>

                            <tr>
                                <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-twitter mg-r-4"></i>Twitter</td>
                                <td className="tx-medium text-right">0</td>
                                <td className="text-right tx-medium tx-primary">0</td>
                                <td className="text-right tx-medium tx-pink">0</td>
                                <td className="text-right tx-medium tx-purple">0</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr/>

                <div className="card-body pd-y-10">
                    <div className="mb-3">
                        <h6 className="mg-b-5">Facebook Pages</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">Influencer Page Stats & Associated Facebook Account.</p>
                    </div>
                    {pages?.length > 0 ? <div className="row mb-3">
                        {pages.map((data) => (
                            <div className="col-sm-6 col-lg-4 mb-3">
                                <div className="card card-body">
                                    <a href={`https://www.facebook.com/${data.id}`} target="_blank" className="link-02">
                                        <div className="d-flex justify-content-between mt-1">
                                            <div className="media">
                                                <div className="crypto-icon crypto-icon-sm bg-primary">
                                                    <img src={data.picture.data.url} className="ht-50 rounded-30" alt="logo"/>
                                                </div>
                                                <div className="media-body mg-l-15">
                                                    <p className="tx-medium mg-b-0">{data.name}</p>
                                                    <p className="mg-b-0 tx-12 tx-color-03 tx-medium tx-spacing-1">{data.category}</p>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <p className="tx-normal tx-rubik mg-b-0">Follower</p>
                                                <p className="tx-normal tx-rubik mg-b-0 float-right">{formatNumber(data.followers_count)}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div> : <h6 className="tx-danger">No Pages Connected.</h6>}
                </div>
            </div>
        </div>
    );
};

export default UserReport;
